import { declareStorageDomain } from './storageGate';
import type { AuthTokens } from '../../models/auth';

// Clés des tokens Stimul'In (source unique). Stockés via Preferences (cross-platform) ;
// l'ancien localStorage brut est migré automatiquement à la lecture (cf. preferences.ts).
const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

const storage = declareStorageDomain({
    name: 'tokens',
    onLogout: async (s) => {
        await s.remove(ACCESS_TOKEN_KEY);
        await s.remove(REFRESH_TOKEN_KEY);
    },
    // Bascule d'identité : les jetons PERSISTÉS (ceux du Pro) survivent — la session
    // accompagnée vit dans l'overlay mémoire ci-dessous, jamais dans le storage.
    onIdentitySwitch: async () => {}
});

// Pile d'identités (sessions accompagnées) : les jetons act-as vivent en MÉMOIRE, jamais
// persistés — fermer l'app ou recharger la page = retour automatique au compte Pro.
// Overlay actif ⇒ les accesseurs servent/écrivent l'overlay : la rotation du refresh
// accompagné ne touche jamais les jetons du Pro, et l'intercepteur axios (api.ts) reste
// strictement inchangé.
let actAsTokens: AuthTokens | null = null;

export const isActAsSessionActive = (): boolean => actAsTokens !== null;

export const enterActAsTokenOverlay = (tokens: AuthTokens): void => {
    actAsTokens = { ...tokens };
};

export const exitActAsTokenOverlay = (): void => {
    actAsTokens = null;
};

export const getAccessToken = (): Promise<string | null> =>
    actAsTokens ? Promise.resolve(actAsTokens.accessToken) : storage.getString(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): Promise<string | null> =>
    actAsTokens ? Promise.resolve(actAsTokens.refreshToken) : storage.getString(REFRESH_TOKEN_KEY);

export const setAccessToken = (token: string): Promise<void> => {
    if (actAsTokens) {
        actAsTokens = { ...actAsTokens, accessToken: token };
        return Promise.resolve();
    }
    return storage.setString(ACCESS_TOKEN_KEY, token);
};

export const setRefreshToken = (token: string): Promise<void> => {
    if (actAsTokens) {
        actAsTokens = { ...actAsTokens, refreshToken: token };
        return Promise.resolve();
    }
    return storage.setString(REFRESH_TOKEN_KEY, token);
};

export async function clearTokens(): Promise<void> {
    // Sous act-as, « perdre les jetons » (échec de refresh : PARENT_REVOKED, rejeu…) met
    // fin au mode accompagné — les jetons du Pro, eux, restent intacts.
    if (actAsTokens) {
        actAsTokens = null;
        return;
    }
    await storage.remove(ACCESS_TOKEN_KEY);
    await storage.remove(REFRESH_TOKEN_KEY);
}
